import { createConfig } from '@privy-io/wagmi'
import { bsc, bscTestnet } from 'viem/chains'
import { http } from 'wagmi'

export const config =
  process.env.mode === 'development'
    ? createConfig({
        chains: [bscTestnet],
        transports: {
          [bscTestnet.id]: http(),
        },
      })
    : createConfig({
        chains: [bsc],
        transports: {
          [bsc.id]: http(),
        },
      })
